import {
  HOME_CARE_SOLUTIONS,
  MEDICAL_SUPPLIES_SOLUTIONS,
  SOLUTION_FULL_TIME_MOBILE_CARE,
  SOLUTION_HELP_AT_HOME,
  SOLUTION_MOBILE_CARE,
} from "core/consts";
import { shouldRedactHouseNumber } from "core/model/auctions";
import type { SearchType, Solutions } from "core/types";

const HOUSE_NUMBER_SOLUTIONS = [
  SOLUTION_MOBILE_CARE,
  SOLUTION_HELP_AT_HOME,
  SOLUTION_FULL_TIME_MOBILE_CARE,
  ...MEDICAL_SUPPLIES_SOLUTIONS,
  ...HOME_CARE_SOLUTIONS,
] as Solutions;

export function requiredHouseNumber({
  search_type,
  share_patient_data_automatically,
  solutions,
}: {
  search_type: SearchType;
  share_patient_data_automatically: boolean | undefined;
  /** Normalized by {@link assessmentSolutionsSchema} on step payloads. */
  solutions?: Solutions | undefined;
}): boolean {
  if (
    shouldRedactHouseNumber({
      search_type,
      share_patient_data_automatically,
    })
  ) {
    return true;
  }

  if (!solutions || solutions.length === 0) {
    return false;
  }
  return !solutions.every((s) => HOUSE_NUMBER_SOLUTIONS.indexOf(s) < 0);
}
